"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = exports.emailRegexp = exports.SMASH_ENV = exports.AWS_REGION = exports.pathRegexp = exports.comma = exports.slash = exports.separator = exports.spacer = exports.star = exports.underscore = exports.dash = exports.wildcard = exports.RegionScope = exports.Effect = exports.Scope = exports.HttpMethod = exports.Env = exports.Region = void 0;
var Region;
(function (Region) {
    Region["us_east_1"] = "us-east-1";
    Region["us_east_2"] = "us-east-2";
    Region["us_west_1"] = "us-west-1";
    Region["us_west_2"] = "us-west-2";
    Region["ap_south_1"] = "ap-south-1";
    Region["ap_northeast_3"] = "ap-northeast-3";
    Region["ap_northeast_2"] = "ap-northeast-2";
    Region["ap_southeast_1"] = "ap-southeast-1";
    Region["ap_southeast_2"] = "ap-southeast-2";
    Region["ap_northeast_1"] = "ap-northeast-1";
    Region["ca_central_1"] = "ca-central-1";
    Region["eu_central_1"] = "eu-central-1";
    Region["eu_west_1"] = "eu-west-1";
    Region["eu_west_2"] = "eu-west-2";
    Region["eu_west_3"] = "eu-west-3";
    Region["eu_north_1"] = "eu-north-1";
    Region["sa_east_1"] = "sa-east-1";
    Region["af_south_1"] = "af-south-1";
    Region["ap_east_1"] = "ap-east-1";
    Region["ap_south_2"] = "ap-south-2";
    Region["ap_southeast_3"] = "ap-southeast-3";
    Region["eu_south_1"] = "eu-south-1";
    Region["eu_south_2"] = "eu-south-2";
    Region["eu_central_2"] = "eu-central-2";
    Region["me_south_1"] = "me-south-1";
    Region["me_central_1"] = "me-central-1";
})(Region = exports.Region || (exports.Region = {}));
var Env;
(function (Env) {
    Env["prod"] = "prod";
    Env["dev"] = "dev";
    Env["test"] = "test";
})(Env = exports.Env || (exports.Env = {}));
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["get"] = "GET";
    HttpMethod["post"] = "POST";
    HttpMethod["put"] = "PUT";
    HttpMethod["patch"] = "PATCH";
    HttpMethod["delete"] = "DELETE";
    HttpMethod["head"] = "HEAD";
    HttpMethod["options"] = "OPTIONS";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
var Scope;
(function (Scope) {
    Scope["public"] = "public";
    Scope["private"] = "private";
    Scope["Public"] = "Public";
    Scope["Private"] = "Private";
})(Scope = exports.Scope || (exports.Scope = {}));
var Effect;
(function (Effect) {
    Effect["allow"] = "Allow";
    Effect["deny"] = "Deny";
})(Effect = exports.Effect || (exports.Effect = {}));
var RegionScope;
(function (RegionScope) {
    RegionScope["all"] = "All";
    RegionScope["self"] = "Self";
})(RegionScope = exports.RegionScope || (exports.RegionScope = {}));
exports.wildcard = '.*';
exports.dash = '-';
exports.underscore = '_';
exports.star = '*';
exports.spacer = ' ';
exports.separator = ':';
exports.slash = '/';
exports.comma = ',';
exports.pathRegexp = '[^\/]+';
exports.AWS_REGION = 'AWS_REGION';
exports.SMASH_ENV = 'ENV';
exports.emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var Language;
(function (Language) {
    Language["en"] = "en";
    Language["fr"] = "fr";
    Language["de"] = "de";
    Language["es"] = "es";
    Language["pt"] = "pt";
    Language["it"] = "it";
})(Language = exports.Language || (exports.Language = {}));
